import React, { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '@descope/react-sdk';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { useGetCurrentUser } from '@/api/generated';
import BackdropLoader from '@/components/BackdropLoader';
import Loader from '@/components/Loader/Loader';
import { GeneralStatusEnum } from '@/components/statuses/GeneralStatus/types';
import { usePostHogIdentify } from '@/hooks/usePostHogIdentify';
import { useSyncI18nWithPreferredLocale } from '@/hooks/useSyncI18nWithPreferredLocale';
import { ROUTER_PATHS } from '@/root/linker';
import AppLayout from '@/views/AppLayout/AppLayout';

const PodiumApp = () => {
  const { isAuthenticated, isSessionLoading } = useSession();
  const { data: currentUser, isLoading: isLoadingUser } = useGetCurrentUser();

  // Identify the user in PostHog as soon as they're authenticated
  usePostHogIdentify();
  useSyncI18nWithPreferredLocale();

  if (isSessionLoading || isLoadingUser) {
    return <BackdropLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTER_PATHS.LOGIN} />;
  }

  if (currentUser?.status === GeneralStatusEnum.ONBOARDING) {
    return <Navigate to={ROUTER_PATHS.ONBOARDING} />;
  }

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <AppLayout>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </AppLayout>
    </QueryParamProvider>
  );
};

export default PodiumApp;
